import { Box, Button, IconButton, Popper, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ExoDrawer from '../ExoDrawer';
import { tokens } from '../../../global/theme/tokens';
import CloseIcon from '@mui/icons-material/Close';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import FlagIcon from '@mui/icons-material/Flag';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { useTranslation } from 'react-i18next';
import { ProjectWorkPackage } from '../project/workPackage/ProjectWorkPackage';

export const GantPopper = ({
  open,
  anchorEl,
  workPackage,
  projectId,
  onClose,
  onEdit,
  inEditMode,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { t } = useTranslation();

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);

  const Container = isSmallScreen ? ExoDrawer : Popper;

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const statusMap = {
    0: {
      label: t('Running'),
      Icon: DirectionsRunIcon,
      color: colors.greenAccent[600],
      opacity: 1,
    },
    1: {
      label: t('Finished'),
      Icon: FlagIcon,
      color: colors.grey[600],
      opacity: 1,
    },
    2: {
      label: t('Infinite'),
      Icon: AllInclusiveIcon,
      color: colors.blueAccent[600],
      opacity: 1,
    },
    3: {
      label: t('Canceled'),
      Icon: ReportGmailerrorredIcon,
      color: colors.redAccent[600],
      opacity: 1,
    },
  };

  const Icon = statusMap[workPackage?.status]?.Icon;

  if (!anchorEl) return;

  return (
    <Container
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      placement="top"
      className="z-[99] "
      limitWidth
    >
      <Box
        className="flex flex-col gap-1 rounded-md " //pl-3 py-3"
        sx={
          isSmallScreen
            ? {
                height: '100%',
              }
            : {
                background: `linear-gradient(135deg,  ${colors.glassFrom}, ${colors.glassTo})`,
                border: `1px solid ${colors.selected}`,
                transform: 'translate(-5px, 0px)',
                //width: '300px',
                //height: '350px',
                maxHeight: '90vh',
                backdropFilter: `blur(5px)`,
              }
        }
      >
        {workPackage && (
          <ProjectWorkPackage
            inGant
            workPackage={workPackage}
            project={{ id: projectId, supervisor: {} }}
          />
        )}
        {inEditMode && (
          <Button
            className=" w-full text-xl"
            variant="contained"
            color="primary"
            onClick={() => onEdit(workPackage)}
          >
            Edit
          </Button>
        )}
      </Box>

      <IconButton
        onClick={onClose}
        className="top-2 right-2 "
        sx={{
          position: 'absolute',
          display: isSmallScreen ? 'none' : 'block',
        }}
      >
        <CloseIcon />
      </IconButton>
    </Container>
  );
};
